module.exports = __webpack_public_path__ + "static/media/download-dark.e79fc9a9.svg";